import React from 'react';
import { wtApiCall } from '../../helpers/commons/ApiWrapper';
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications';
import { CCol, CRow } from '@coreui/react';
import './index.css';
import Highcharts from 'highcharts';
import drilldown from 'highcharts/modules/drilldown.js';
import HighchartsReact from 'highcharts-react-official';
import Loading from 'src/helpers/commons/loader';
import { wtFormatMoneyRoundData, wtFormatRoundedValue, wtRoundValue } from 'src/helpers/commons/utils';
import { Table, Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import { currentFullYear } from 'src/helpers/commons/moment';


const branches = wtGetFromLocalStorage("branches");
class FinanceDashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            isLoading: false,
            searchText: '',
            searchedColumn: '',
            branchId: 0,
            branchName: '',
        };
    }

    componentDidMount() {
        this.loadList();
    }

    loadList() {
        this.setState({ isLoading: true });

        wtApiCall(
            "reports/finance_dashboard",
            {
                branch_id: this.state.branchId
            },
            "get",
            (result) => {
                if (typeof result !== 'undefined') {
                    this.setState({
                        data: result.data
                    });
                }
                this.setState({ isLoading: false });
            },
            (result) => {
                lzNotifyErrorMessageFromResult(result);
                this.setState({ isLoading: false });
            }
        );
    }

    changeValues(key, val) {
        if (key === 'branch_id') {
            this.setState({ branchId: val.value, branchName: val.label }, () => this.loadList());
        }
    }

    render() {
        const {
            isLoading,
            data,
            branchId,
            branchName
        } = this.state;

        if (isLoading) {
            return Loading;
        }

        const profitAndLossChartoptions = {
            chart: {
                type: 'column'
            },
            title: {
                text: 'Monthly Income, Expense, and Profit (' + currentFullYear() + ")"
            },
            xAxis: {
                categories: data?.profit_and_loss_chart_data['categories'],
                crosshair: true
            },
            yAxis: {
                // min: 0,
                title: {
                    text: 'Amount'
                },
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormatter: function () {
                    return `<tr><td style="color:${this.series.color};padding:0">${this.series.name}: </td>` +
                        `<td style="padding:0"><b>${wtFormatMoneyRoundData(this.y, "Rs. ", true, 2)}</b></td></tr>`;
                },
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [
                {
                    name: 'Income',
                    data: data?.profit_and_loss_chart_data['income']
                },
                {
                    name: 'Expense',
                    data: data?.profit_and_loss_chart_data['expense']
                },
                {
                    name: 'Profit',
                    data: data?.profit_and_loss_chart_data['profit']
                }
            ]
        }



        const IncomePieChart = {
            chart: {
                type: 'pie',
            },
            title: {
                text: 'Income Breakdown (' + currentFullYear() + ')'
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormatter: function () {
                    return `<tr><td style="color:${this.series.color};padding:0">${this.series.name}: </td>` +
                        `<td style="padding:0"><b>${wtFormatMoneyRoundData(this.y, "Rs. ", true, 2)}</b></td></tr>`;
                },
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [
                {
                    name: 'Income',
                    data: data?.income_breakdown_chart_data[0]?.children
                }
            ]
        };

        const ExpensePieChart = {
            chart: {
                type: 'pie',
            },
            title: {
                text: 'Expense Breakdown (' + currentFullYear() + ')'
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormatter: function () {
                    return `<tr><td style="color:${this.series.color};padding:0">${this.series.name}: </td>` +
                        `<td style="padding:0"><b>${wtFormatMoneyRoundData(this.y, "Rs. ", true, 2)}</b></td></tr>`;
                },
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            series: [
                {
                    name: 'Expenses',
                    data: data?.expense_breakdown_chart_data[0]?.children
                }
            ]
        };


        return (

            <div className='container-fluid' style={{
                padding: "1em", backgroundColor: "#E5E5E5", minHeight: "100vh", fontFamily: "Helvetica",
                pointerEvents: (isLoading) ? 'none' : 'auto'
            }
            }>
                {data !== null &&
                    <>
                        <CRow style={{ fontFamily: "sans-serif", fontWeight: "bolder", width: '100%' }}>
                            <CCol md="12">
                                <CRow>
                                    <CCol md="2">
                                        <div className="ceo-dashboard-parent-box"
                                            style={{ textAlign: "left", color: "#1C6BB8" }}
                                        >
                                            <h4 style={{ fontWeight: 700 }}> Finance Dashboard</h4>
                                        </div>

                                        <div className="ceo-dashboard-parent-box">
                                            <div className="ceo-dashboard-child-box">
                                                <img style={{ height: 30, top: 8, left: 15, position: "relative", }}
                                                    src={"avatars/finance-dashboard-icons/asset.png"} alt="headcount.png" />
                                                <div style={{ position: "relative" }}>
                                                    <span style={{ left: 70, position: "absolute", fontSize: 14, bottom: 22 }}>
                                                        Total Assets
                                                    </span>
                                                    <br />
                                                    <span style={{ left: 70, top: 1, position: "absolute", fontSize: 14, bottom: 1 }}>
                                                        {wtFormatRoundedValue(data.total_assets, "Rs. ", true, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ceo-dashboard-parent-box">
                                            <div className="ceo-dashboard-child-box">
                                                <img style={{ height: 30, top: 8, left: 15, position: "relative", }}
                                                    src={"avatars/finance-dashboard-icons/liability.png"} alt="average-age.png" />
                                                <div style={{ position: "relative" }}>
                                                    <span style={{ left: 70, position: "absolute", fontSize: 14, bottom: 22 }}>
                                                        Total Liabilities
                                                    </span>
                                                    <br />
                                                    <span style={{ left: 70, top: 1, position: "absolute", fontSize: 14, bottom: 1 }}>
                                                        {wtFormatRoundedValue(data.total_liabilities, "Rs. ", true, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ceo-dashboard-parent-box">
                                            <div className="ceo-dashboard-child-box">
                                                <img style={{ height: 30, top: 8, left: 8, position: "relative", }}
                                                    src={"avatars/finance-dashboard-icons/equity.png"} alt="average-tenure.png" />
                                                <div style={{ position: "relative" }}>
                                                    <span style={{ left: 70, position: "absolute", fontSize: 14, bottom: 22 }}>
                                                        Total Equity
                                                    </span>
                                                    <br />
                                                    <span style={{ left: 70, top: 1, position: "absolute", fontSize: 14, bottom: 1 }}>
                                                        {wtFormatRoundedValue(data.total_equity, "Rs. ", true, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ceo-dashboard-parent-box">
                                            <div className="ceo-dashboard-child-box">
                                                <img style={{ height: 30, top: 8, left: 8, position: "relative", }}
                                                    src={"avatars/finance-dashboard-icons/profit.png"} alt="average-tenure.png" />
                                                <div style={{ position: "relative" }}>
                                                    <span style={{ left: 60, position: "absolute", fontSize: 14, bottom: 22 }}>
                                                        {"Total Revenue (" + currentFullYear() + ")"}
                                                    </span>
                                                    <br />
                                                    <span style={{ left: 70, top: 1, position: "absolute", fontSize: 14, bottom: 1 }}>
                                                        {wtFormatRoundedValue(data.total_income, "Rs. ", true, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ceo-dashboard-parent-box">
                                            <div className="ceo-dashboard-child-box">
                                                <img style={{ height: 30, top: 8, left: 8, position: "relative", }}
                                                    src={"avatars/finance-dashboard-icons/expense.png"} alt="average-tenure.png" />
                                                <div style={{ position: "relative" }}>
                                                    <span style={{ left: 60, position: "absolute", fontSize: 14, bottom: 22 }}>
                                                        {"Total Expense (" + currentFullYear() + ")"}
                                                    </span>
                                                    <br />
                                                    <span style={{ left: 70, top: 1, position: "absolute", fontSize: 14, bottom: 1 }}>
                                                        {wtFormatRoundedValue(data.total_expense, "Rs. ", true, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ceo-dashboard-parent-box">
                                            <div className="ceo-dashboard-child-box">
                                                <img style={{ height: 30, top: 8, left: 8, position: "relative", }}
                                                    src={"avatars/finance-dashboard-icons/net-profit.png"} alt="average-tenure.png" />
                                                <div style={{ position: "relative" }}>
                                                    <span style={{ left: 50, position: "absolute", fontSize: 14, bottom: 22 }}>
                                                        {"Total Net Profit (" + currentFullYear() + ")"}
                                                    </span>
                                                    <br />
                                                    <span style={{ left: 70, top: 1, position: "absolute", fontSize: 14, bottom: 1 }}>
                                                        {wtFormatRoundedValue((data.total_income - data.total_expense), "Rs. ", true, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ceo-dashboard-parent-box">
                                            <div className="ceo-dashboard-child-box">
                                                <img style={{ height: 30, top: 8, left: 8, position: "relative", }}
                                                    src={"avatars/finance-dashboard-icons/cash-inflow.png"} alt="average-tenure.png" />
                                                <div style={{ position: "relative" }}>
                                                    <span style={{ left: 60, position: "absolute", fontSize: 14, bottom: 22 }}>
                                                        {"Total Inflows (" + currentFullYear() + ")"}
                                                    </span>
                                                    <br />
                                                    <span style={{ left: 70, top: 1, position: "absolute", fontSize: 14, bottom: 1 }}>
                                                        {wtFormatRoundedValue((data.total_inflows), "Rs. ", true, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ceo-dashboard-parent-box">
                                            <div className="ceo-dashboard-child-box">
                                                <img style={{ height: 30, top: 8, left: 8, position: "relative", }}
                                                    src={"avatars/finance-dashboard-icons/cash-outflow.png"} alt="average-tenure.png" />
                                                <div style={{ position: "relative" }}>
                                                    <span style={{ left: 60, position: "absolute", fontSize: 14, bottom: 22 }}>
                                                        {"Total Outflows (" + currentFullYear() + ")"}
                                                    </span>
                                                    <br />
                                                    <span style={{ left: 70, top: 1, position: "absolute", fontSize: 14, bottom: 1 }}>
                                                        {wtFormatRoundedValue((data.total_outflows), "Rs. ", true, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                    </CCol>

                                    <CCol md="10">
                                        <div style={{ width: 300, float: "right" }}>
                                            <WidgetBranchSelector
                                                value={branchId}
                                                displayValue={branchName}
                                                branches={branches}
                                                placeholder="Select Branch"
                                                onChange={(values) => this.changeValues('branch_id', values)}
                                                showCloudIcon={false}
                                            />
                                        </div>
                                        <div
                                            style={{ height: "fit-content", marginTop: 50 }}
                                        >
                                            <HighchartsReact highcharts={Highcharts} options={profitAndLossChartoptions} />
                                        </div>

                                        <br />

                                        <div style={{ display: "inline-block", marginTop: 30 }}>
                                            <div style={{ display: "inline-block" }}>
                                                <HighchartsReact highcharts={Highcharts} options={IncomePieChart} />
                                            </div>

                                            <div style={{ display: "inline-block", marginLeft: 20 }}>
                                                <HighchartsReact highcharts={Highcharts} options={ExpensePieChart} />
                                            </div>
                                        </div>

                                    </CCol>

                                </CRow>
                            </CCol>
                        </CRow>
                    </>
                }
            </div >
        )
    }
}
export default FinanceDashboard;
